import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      // Only scroll to top if navigating to login page
      if (pathname.includes('/auth/login')) {
        window.scrollTo(0, 0);
      }
      prevPathname.current = pathname;
    }
  }, [pathname]);

  return null;
}
